import React, { ReactNode } from "react";
import * as Styled from "./RichTextListItem.styled";

const RichTextListItem: React.FC<{ children: ReactNode }> = ({ children }) => {
  return <Styled.ListItem>{children}</Styled.ListItem>;
};

export default RichTextListItem;
